/* ===================================================================
   BAMBOOVE — HANH VI HEADER (bo tro cho `bamboove-header.css`)
   Phan 2 (header) dang lam.

   NGAN KEO ☰: Bamboove chi cho `on:click` chay **1 lenh** (`selector/method`,
   xem `assets/component.js` dong 264: `value.split('/')` — KHONG hieu dau `;`).
   Ma o tim kiem trong ngan keo phai lam 2 viec: (1) dong ngan keo, (2) mo hop
   thoai tim kiem. => Tach ra: `on:click` lo (2), tep nay lo (1).

   ⚠️ BAY DA DINH (01/10/2026): `DialogOpenEvent` duoc tao bang
   `new CustomEvent(ten)` (assets/dialog.js d.159-165) => **KHONG BUBBLE**.
   Vi vay `document.addEventListener('dialog:open', fn)` KHONG BAO GIO CHAY.
   Phai nghe o **pha CAPTURE** (`fn, true`) thi su kien moi di qua document.
   (Da do: truoc khi sua => `khay_con_mo: True`; sau khi sua => `False`.)
   =================================================================== */
document.addEventListener(
  'dialog:open',
  (event) => {
    const dialog = event.target;
    if (!dialog || dialog.id !== 'search-modal') return;

    // `open` nam tren <details> BEN TRONG <header-drawer>, khong phai tren chinh no.
    const khay = document.querySelector('header-drawer');
    const details = khay ? khay.querySelector('details') : null;
    if (!details || !details.hasAttribute('open')) return;

    if (typeof khay.close === 'function') {
      khay.close();
    } else {
      details.removeAttribute('open');
    }
  },
  true
);

